<template>
	<div class="quillContainer">
		<el-row class="newsOne">
			<el-col :span="2">新闻类型：</el-col>
			<el-col :span="10">
				<el-select v-model="id" placeholder="请选择"><el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option></el-select>
			</el-col>
			<el-col :span="2">新闻标题：</el-col>
			<el-col :span="10"><el-input v-model="titleInput" placeholder="请输入新闻标题"></el-input></el-col>
		</el-row>
		<el-row class="newsTwo">
			<el-col :span="2">新闻封面：</el-col>
			<el-col :span="22">
				<el-upload
					ref="upload"
					class="avatar-uploader"
					:http-request="upLoad"
					action="aaa"
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload"
				>
					<img v-if="newsImageUrl" :src="newsImageUrl" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-col>
		</el-row>
		<quill-editor ref="quillConent"></quill-editor>
		<p class="save"><el-button type="primary" @click="saveHtml">保存</el-button></p>
	</div>
</template>

<script>
	import quillEditor from "@/page/Admin/news/quill/quill.vue"
export default {
	components:{
		quillEditor
	},
	data() {
		return {
			titleInput: '',
			options: [],
			id: '',
			newsImageUrl: '',
			dialogVisible: false
		};
	},
	created() {
		this.getType();
	},
	methods: {
		upLoad(file) {
			const formData = new FormData();
			formData.append('file', file.file);
			formData.append('path', 'news');
			this.$post('file/upload', formData)
				.then(res => res.data)
				.then(data => {
					if (data.code == 0) {
						this.$message({
							message: data.message,
							type: 'success'
						});
						this.newsImageUrl = this.$Url+data.data;
					}
				});
		},
		handleAvatarSuccess(res, file) {
			this.imageUrl = URL.createObjectURL(file.raw);
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isJPG) {
				this.$message.error('上传头像图片只能是 JPG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
			}
			return isJPG && isLt2M;
		},

		getType() {
			this.$get('type/list').then(res => {
				this.options = res.list;
			});
		},
		//保存
		saveHtml() {
			var that = this;
			if (that.id == '') {
				return that.$message({
					message: '请选择新闻类型！'
				});
			} else if (that.titleInput == '') {
				return that.$message({
					message: '请输入新闻标题！'
				});
			} else if (that.dialogImageUrl == '') {
				return that.$message({
					message: '请选择新闻封面！'
				});
			} else if (that.content == '<p></p><p></p>') {
				return that.$message({
					message: '请输入内容！'
				});
			}
			let data = new FormData();
			data.append('tId', this.id);
			data.append('title', this.titleInput);
			data.append('coverl', this.newsImageUrl);
			data.append('content', this.$refs.quillConent.editeContent);

			this.$post('newslist/add', data).then(res => {
				window.console.log(res);
				if (res.data.code == 0) {
					that.$message({
						message: res.data.message,
						type: 'success',
						duration: 1000
					});
					setTimeout(function() {
						that.id = '',
							that.titleInput = '',
							that.$refs.upload.clearFiles(), //清空图片
							that.$refs.quillConent.editeContent = "";
					}, 1000);
				}
				// this.options = res;
			});
		}
	}
};
</script>
<style>
.quillContainer .el-select {
	width: 100%;
}
.quillContainer .newsOne {
	height: 50px;
	padding: 5px;
	line-height: 38px !important;
}
.quillContainer .newsOne:first-of-type,
.quillContainer .newsOne:nth-of-type(3) {
	text-align: center;
}
.edit_container {
	/* height:600px; */
	height: 80%;
	margin-top: 10px;
}
.ql-container .ql-snow {
	height: 300px !important;
}

.save {
	margin-top: 20px;
	text-align: center;
}
.newsTwo {
	padding: 5px;
}
.newsTwo > .el-col:first-of-type {
	text-align: center;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.quillContainer .el-row .el-col{
	font-size: 16px!important;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.disabled .el-upload--picture-card {
	display: none;
}
</style>
